import React from 'react';
import {
  MdOutlineSentimentSatisfied,
  MdOutlineSentimentNeutral,
  MdOutlineSentimentDissatisfied,
} from 'react-icons/md';
import { Card, CardBody } from 'reactstrap';

interface EvaluationCardProps {
  percentage1?: number; // Bom
  percentage2?: number; // Neutro
  percentage3?: number; // Ruim
  total?: number;
  style?: React.CSSProperties; // ✅ novo
}

const EvaluationCard: React.FC<EvaluationCardProps> = ({
  percentage1 = 59,
  percentage2 = 25,
  percentage3 = 16,
  total = 458,
  style,
}) => {
  const color = '#2A2C85';
  const bgColor = '#edf3ff';

  return (
    <Card
      style={{
        minWidth: '189px',
        width: '100%',
        maxWidth: 250,
        maxHeight: '500px',
        height: '100%',
        border: 'none',
        borderRadius: 8,
        ...style, // ✅ aplica style externo
      }}
    >
      <CardBody
        style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column' }}
      >
        <h6 style={{ fontWeight: '500', fontSize: 16, color: '#5A5A5A', marginBottom: 30 }}>
          Avaliação - Eventos
        </h6>

        {/* Linha Bom */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center',
            marginBottom: '30px',
          }}
        >
          <div
            style={{
              width: 48,
              height: 48,
              backgroundColor: bgColor,
              borderRadius: 8,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <MdOutlineSentimentSatisfied size={26} color={color} />
          </div>
          <span style={{ color, fontSize: 14, fontWeight: 400 }}>Bom</span>
          <span style={{ color, fontSize: 18, fontWeight: 700 }}>{percentage1}%</span>
        </div>

        {/* Linha Neutro */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center',
            marginBottom: '30px',
          }}
        >
          <div
            style={{
              width: 48,
              height: 48,
              backgroundColor: bgColor,
              borderRadius: 8,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <MdOutlineSentimentNeutral size={26} color={color} />
          </div>
          <span style={{ color, fontSize: 14, fontWeight: 400 }}>Neutro</span>
          <span style={{ color, fontSize: 18, fontWeight: 700 }}>{percentage2}%</span>
        </div>

        {/* Linha Ruim */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center',
            marginBottom: '30px',
          }}
        >
          <div
            style={{
              width: 48,
              height: 48,
              backgroundColor: bgColor,
              borderRadius: 8,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <MdOutlineSentimentDissatisfied size={26} color={color} />
          </div>
          <span style={{ color, fontSize: 14, fontWeight: 400 }}>Ruim</span>
          <span style={{ color, fontSize: 18, fontWeight: 700 }}>{percentage3}%</span>
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 8,
            marginTop: 20,
          }}
        >
          <span
            style={{
              fontWeight: '400',
              fontSize: 12,
              color: '#5A5A5A',
            }}
          >
            Total de avaliações:
          </span>
          <span
            style={{
              fontWeight: '400',
              fontSize: 14,
              color: '#2A2C85',
            }}
          >
            {total}
          </span>
        </div>
      </CardBody>
    </Card>
  );
};

export default EvaluationCard;
